import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dacd43f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "postgraduate" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("研究生信息")
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "serach-box" }
const _hoisted_5 = { class: "item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, "姓名：", -1))
const _hoisted_7 = { class: "item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, "院校：", -1))
const _hoisted_9 = { class: "item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, "专业：", -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 一键导出 ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 复制模板 ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 新建 ")
const _hoisted_15 = { class: "table" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 研究生性别: ")
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 2 }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 入学时间: ")
const _hoisted_21 = { key: 0 }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" 上岸途径: ")
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = ["src"]
const _hoisted_26 = /*#__PURE__*/_createTextVNode("暂无头像")
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { key: 2 }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = /*#__PURE__*/_createTextVNode("是")
const _hoisted_38 = /*#__PURE__*/_createTextVNode("否")
const _hoisted_39 = /*#__PURE__*/_createTextVNode("点击查看")
const _hoisted_40 = /*#__PURE__*/_createTextVNode("暂无图片")
const _hoisted_41 = /*#__PURE__*/_createTextVNode("点击查看")
const _hoisted_42 = /*#__PURE__*/_createTextVNode("暂无图片")
const _hoisted_43 = /*#__PURE__*/_createTextVNode("点击查看")
const _hoisted_44 = /*#__PURE__*/_createTextVNode("暂无图片")
const _hoisted_45 = /*#__PURE__*/_createTextVNode("点击查看")
const _hoisted_46 = /*#__PURE__*/_createTextVNode("暂无图片")
const _hoisted_47 = /*#__PURE__*/_createTextVNode("已发布")
const _hoisted_48 = /*#__PURE__*/_createTextVNode("未发布")
const _hoisted_49 = /*#__PURE__*/_createTextVNode("发布")
const _hoisted_50 = /*#__PURE__*/_createTextVNode(" 修改 ")
const _hoisted_51 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_52 = { class: "pagination" }
const _hoisted_53 = /*#__PURE__*/_createTextVNode(" 识别 ")
const _hoisted_54 = { class: "aval-list" }
const _hoisted_55 = ["src"]
const _hoisted_56 = /*#__PURE__*/_createTextVNode("选择头像")
const _hoisted_57 = ["src", "onClick"]
const _hoisted_58 = /*#__PURE__*/_createTextVNode("男")
const _hoisted_59 = /*#__PURE__*/_createTextVNode("女")
const _hoisted_60 = /*#__PURE__*/_createTextVNode(" (可输入关键字) ")
const _hoisted_61 = /*#__PURE__*/_createTextVNode(" + New Tag ")
const _hoisted_62 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_63 = /*#__PURE__*/_createTextVNode(" 确定 ")
const _hoisted_64 = /*#__PURE__*/_createTextVNode("Ctrl+A全部选中，Ctrl+C复制，Ctrl+V粘贴")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_tag, { type: "success" }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_el_input, {
            modelValue: _ctx.search.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search.name) = $event)),
            placeholder: "输入需要查询的姓名",
            clearable: "",
            onKeyup: _withKeys($setup.handleSearch, ["enter"])
          }, null, 8, ["modelValue", "onKeyup"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(_component_el_input, {
            modelValue: _ctx.search.college,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search.college) = $event)),
            placeholder: "输入需要查询的院校",
            clearable: "",
            onKeyup: _withKeys($setup.handleSearch, ["enter"])
          }, null, 8, ["modelValue", "onKeyup"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode(_component_el_input, {
            modelValue: _ctx.search.major,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.search.major) = $event)),
            placeholder: "输入需要查询的专业",
            clearable: "",
            onKeyup: _withKeys($setup.handleSearch, ["enter"])
          }, null, 8, ["modelValue", "onKeyup"])
        ]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: $setup.handleSearch
        }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_el_button, {
          type: "primary",
          style: {"width":"100px"},
          onClick: $setup.handleExport
        }, {
          default: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          type: "primary",
          style: {"width":"100px"},
          onClick: $setup.handleCopyTemp
        }, {
          default: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          type: "primary",
          style: {"width":"100px"},
          onClick: $setup.handleCreate
        }, {
          default: _withCtx(() => [
            _hoisted_14
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: _ctx.tableData,
        border: "",
        style: {"width":"100%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            align: "center",
            fixed: "",
            prop: "id",
            width: "60"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            fixed: "",
            prop: "name",
            label: "姓名",
            "show-overflow-tooltip": "",
            width: "100"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_popover, {
                effect: "light",
                trigger: "hover",
                placement: "right",
                width: "300px"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, "昵称：" + _toDisplayString(scope.row.nickname), 1),
                  _createElementVNode("div", null, "研究生姓名: " + _toDisplayString(scope.row.name), 1),
                  _createElementVNode("div", null, [
                    _hoisted_16,
                    (scope.row.sex === 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, "男"))
                      : (scope.row.sex === 2)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, "女"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_19, "暂无"))
                  ]),
                  _createElementVNode("div", null, "手机号码: " + _toDisplayString(scope.row.contact), 1),
                  _createElementVNode("div", null, "微信: " + _toDisplayString(scope.row.wechatNum), 1),
                  _createElementVNode("div", null, "院校: " + _toDisplayString(scope.row.college), 1),
                  _createElementVNode("div", null, "院系: " + _toDisplayString(scope.row.academy), 1),
                  _createElementVNode("div", null, "专业: " + _toDisplayString(scope.row.major), 1),
                  _createElementVNode("div", null, "方向: " + _toDisplayString(scope.row.direction), 1),
                  _createElementVNode("div", null, [
                    _hoisted_20,
                    (scope.row.entranceTime)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(scope.row.entranceTime.slice(0, 10)), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", null, "英语几：" + _toDisplayString(scope.row.englishName), 1),
                  _createElementVNode("div", null, "数学几：" + _toDisplayString(scope.row.mathName), 1),
                  _createElementVNode("div", null, "专业课一：" + _toDisplayString(scope.row.zyk1Name), 1),
                  _createElementVNode("div", null, "专业课二：" + _toDisplayString(scope.row.zyk2Name), 1),
                  _createElementVNode("div", null, "政治: " + _toDisplayString(scope.row.polScore), 1),
                  _createElementVNode("div", null, "英语: " + _toDisplayString(scope.row.engScore), 1),
                  _createElementVNode("div", null, "专业课1: " + _toDisplayString(scope.row.zykOne), 1),
                  _createElementVNode("div", null, "专业课2: " + _toDisplayString(scope.row.zykTwo), 1),
                  _createElementVNode("div", null, "总分: " + _toDisplayString(scope.row.totalScore), 1),
                  _createElementVNode("div", null, "复试成绩: " + _toDisplayString(scope.row.retestScore), 1),
                  _createElementVNode("div", null, "初试排名：" + _toDisplayString(scope.row.initialRank), 1),
                  _createElementVNode("div", null, "复试排名：" + _toDisplayString(scope.row.againRank), 1),
                  _createElementVNode("div", null, "总成绩排名：" + _toDisplayString(scope.row.totalRank), 1),
                  _createElementVNode("div", null, [
                    _hoisted_22,
                    (scope.row.successWay === '1')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_23, "一志愿"))
                      : _createCommentVNode("", true),
                    (scope.row.successWay === '2')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_24, "调剂"))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", null, "辅导经验: " + _toDisplayString(scope.row.guideExperience), 1),
                  _createElementVNode("div", null, "渠道: " + _toDisplayString(scope.row.channel), 1),
                  _createElementVNode("div", null, "备注: " + _toDisplayString(scope.row.remark), 1)
                ]),
                reference: _withCtx(() => [
                  _createElementVNode("div", null, _toDisplayString(scope.row.name), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "avatar",
            label: "头像",
            width: "120"
          }, {
            default: _withCtx((scope) => [
              (scope.row.avatar)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    style: {"width":"80px","height":"80px","border-radius":"50%"},
                    src: scope.row.avatar,
                    alt: ""
                  }, null, 8, _hoisted_25))
                : (_openBlock(), _createBlock(_component_el_tag, {
                    key: 1,
                    type: "warning"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_26
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "sex",
            label: "性别",
            width: "70"
          }, {
            default: _withCtx((scope) => [
              (scope.row.sex === 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_27, "男"))
                : (scope.row.sex === 2)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_28, "女"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_29, "暂无"))
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "contact",
            label: "手机号码",
            width: "120"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "wechatNum",
            label: "微信",
            width: "150"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "college",
            label: "院校",
            width: "150"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "academy",
            label: "院系",
            width: "180"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "major",
            label: "专业",
            width: "180"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "direction",
            label: "方向",
            width: "180"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "entranceTime",
            label: "入学时间",
            width: "110"
          }, {
            default: _withCtx((scope) => [
              (scope.row.entranceTime)
                ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(scope.row.entranceTime.slice(0, 10)), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "polScore",
            label: "政治",
            width: "60"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "engScore",
            label: "英语",
            width: "120"
          }, {
            default: _withCtx((scope) => [
              (scope.row.engScore)
                ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(scope.row.englishName) + " " + _toDisplayString(scope.row.engScore), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "mathScore",
            label: "数学",
            width: "120"
          }, {
            default: _withCtx((scope) => [
              (scope.row.engScore)
                ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(scope.row.mathName) + " " + _toDisplayString(scope.row.mathScore), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "zykOne",
            label: "专业课1",
            width: "120"
          }, {
            default: _withCtx((scope) => [
              (scope.row.engScore)
                ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(scope.row.zyk1Name) + " " + _toDisplayString(scope.row.zykOne), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "zykTwo",
            label: "专业课2",
            width: "120"
          }, {
            default: _withCtx((scope) => [
              (scope.row.engScore)
                ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(scope.row.zyk2Name) + " " + _toDisplayString(scope.row.zykTwo), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "totalScore",
            label: "总分",
            width: "60"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "initialRank",
            label: "初试排名",
            width: "90"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "againRank",
            label: "复试排名",
            width: "90"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "totalRank",
            label: "总分排名",
            width: "90"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "retestScore",
            label: "复试成绩",
            width: "90"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "successWay",
            label: "上岸途径",
            width: "100"
          }, {
            default: _withCtx((scope) => [
              (scope.row.successWay === '1')
                ? (_openBlock(), _createElementBlock("span", _hoisted_35, "一志愿"))
                : _createCommentVNode("", true),
              (scope.row.successWay === '2')
                ? (_openBlock(), _createElementBlock("span", _hoisted_36, "调剂"))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "guideExperience",
            label: "辅导经验",
            width: "100"
          }, {
            default: _withCtx((scope) => [
              (scope.row.guideExperience)
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 0,
                    type: "success"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_37
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_el_tag, {
                    key: 1,
                    type: "warning"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_38
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "channel",
            label: "渠道",
            width: "100"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "zykService",
            label: "专业课服务",
            width: "100"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "mathService",
            label: "数学服务",
            width: "100"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "politicsService",
            label: "政治服务",
            width: "100"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "englishService",
            label: "英语服务",
            width: "100"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "otherService",
            label: "其他服务",
            width: "100"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "availInfo",
            label: "可提供资料",
            width: "100"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "tutorAdvantage",
            label: "辅导优势",
            width: "100"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "tag",
            label: "标签",
            width: "150"
          }, {
            default: _withCtx((scope) => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.stringToArr(scope.row.tag), (item, index) => {
                return (_openBlock(), _createBlock(_component_el_tag, {
                  key: index,
                  type: "success",
                  style: {"margin-right":"5px","margin-bottom":"5px"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "remark",
            label: "备注",
            "show-overflow-tooltip": "",
            width: "150"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "studentIdCard",
            label: "学生证",
            width: "100"
          }, {
            default: _withCtx((scope) => [
              (scope.row.studentIdCard)
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 0,
                    onClick: ($event: any) => ($setup.showDetail(scope.row.studentIdCard))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_39
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : (_openBlock(), _createBlock(_component_el_tag, {
                    key: 1,
                    type: "warning"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_40
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "reportCard",
            label: "成绩单",
            width: "100"
          }, {
            default: _withCtx((scope) => [
              (scope.row.reportCard)
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 0,
                    onClick: ($event: any) => ($setup.showDetail(scope.row.reportCard))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_41
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : (_openBlock(), _createBlock(_component_el_tag, {
                    key: 1,
                    type: "warning"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_42
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "reportCard",
            label: "录取通知书",
            width: "100"
          }, {
            default: _withCtx((scope) => [
              (scope.row.offer)
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 0,
                    onClick: ($event: any) => ($setup.showDetail(scope.row.offer))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_43
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : (_openBlock(), _createBlock(_component_el_tag, {
                    key: 1,
                    type: "warning"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_44
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "preOffer",
            label: "拟录取截图",
            width: "100"
          }, {
            default: _withCtx((scope) => [
              (scope.row.preOffer)
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 0,
                    onClick: ($event: any) => ($setup.showDetail(scope.row.preOffer))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_45
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : (_openBlock(), _createBlock(_component_el_tag, {
                    key: 1,
                    type: "warning"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_46
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            fixed: "right",
            align: "center",
            prop: "isPass",
            label: "发布状态",
            width: "100"
          }, {
            default: _withCtx((scope) => [
              (scope.row.isPass)
                ? (_openBlock(), _createBlock(_component_el_tag, { key: 0 }, {
                    default: _withCtx(() => [
                      _hoisted_47
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_el_tag, {
                    key: 1,
                    type: "warning"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_48
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            fixed: "right",
            label: "操作",
            width: "200"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                type: "success",
                size: "small",
                disabled: scope.row.isPass,
                onClick: ($event: any) => ($setup.handlePass(scope.row))
              }, {
                default: _withCtx(() => [
                  _hoisted_49
                ]),
                _: 2
              }, 1032, ["disabled", "onClick"]),
              _createVNode(_component_el_button, {
                type: "warning",
                size: "small",
                onClick: ($event: any) => ($setup.handleEdit(scope.row))
              }, {
                default: _withCtx(() => [
                  _hoisted_50
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_popconfirm, {
                title: "是否删除该条研究生信息?",
                onConfirm: ($event: any) => ($setup.handleDelete(scope.row.id))
              }, {
                reference: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "danger",
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_51
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1032, ["onConfirm"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, _ctx.tableLoading]
      ])
    ]),
    _createElementVNode("div", _hoisted_52, [
      _createVNode(_component_el_pagination, {
        "page-sizes": [100, 200, 300, 400],
        "page-size": _ctx.pageSize,
        "current-page": _ctx.currentPage,
        background: "",
        layout: "total, prev, pager, next, sizes",
        total: _ctx.totalPage,
        onSizeChange: $setup.handleSizeChange,
        onCurrentChange: $setup.handleCurrentChange
      }, null, 8, ["page-size", "current-page", "total", "onSizeChange", "onCurrentChange"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      title: _ctx.popStatus ? '编辑信息' : '新增信息',
      width: "600px",
      onClose: _cache[44] || (_cache[44] = ($event: any) => (_ctx.isShowAvatarPop = false))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "ruleFormRef",
          rules: _ctx.rules,
          model: _ctx.userInfo,
          "label-width": "120px",
          onClick: _withModifiers($setup.handleClose, ["stop"])
        }, {
          default: _withCtx(() => [
            (_ctx.popStatus !== 1)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "智能识别"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.quickCont,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.quickCont) = $event)),
                      type: "textarea",
                      autosize: "",
                      style: {"width":"350px"},
                      placeholder: "可粘贴信息，系统智能识别"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      style: {"width":"80px","margin-left":"10px"},
                      loading: _ctx.btnLoading,
                      onClick: $setup.handleDistinguish
                    }, {
                      default: _withCtx(() => [
                        _hoisted_53
                      ]),
                      _: 1
                    }, 8, ["loading", "onClick"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, {
              label: "姓名",
              prop: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.userInfo.name,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.userInfo.name) = $event)),
                  placeholder: "请输入姓名"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "头像" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_54, [
                  (_ctx.userInfo.avatar)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "user-aval",
                        src: _ctx.userInfo.avatar,
                        alt: "",
                        onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => ($setup.handleShowAvatarPop && $setup.handleShowAvatarPop(...args)), ["stop"]))
                      }, null, 8, _hoisted_55))
                    : (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        onClick: _withModifiers($setup.handleShowAvatarPop, ["stop"])
                      }, {
                        default: _withCtx(() => [
                          _hoisted_56
                        ]),
                        _: 1
                      }, 8, ["onClick"])),
                  (_ctx.isShowAvatarPop)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        class: "aval-item-box",
                        onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imgList, (item, index) => {
                          return (_openBlock(), _createElementBlock("img", {
                            key: index,
                            class: "aval-item",
                            src: item.avatar,
                            alt: "头像",
                            onClick: _withModifiers(($event: any) => ($setup.handleSelectAvatar(item)), ["stop"])
                          }, null, 8, _hoisted_57))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "昵称",
              prop: "nickname"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.userInfo.nickname,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.userInfo.nickname) = $event)),
                  placeholder: "请输入昵称"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "性别",
              prop: "sex"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, {
                  modelValue: _ctx.userInfo.sex,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.userInfo.sex) = $event)),
                  label: 1
                }, {
                  default: _withCtx(() => [
                    _hoisted_58
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_radio, {
                  modelValue: _ctx.userInfo.sex,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.userInfo.sex) = $event)),
                  label: 2
                }, {
                  default: _withCtx(() => [
                    _hoisted_59
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "手机号码",
              prop: "contact"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.userInfo.contact,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.userInfo.contact) = $event)),
                  placeholder: "请输入手机号码"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "微信号",
              prop: "wechatNum"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.userInfo.wechatNum,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.userInfo.wechatNum) = $event)),
                  placeholder: "请输入微信号"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "院校",
              prop: "college"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.userInfo.college,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.userInfo.college) = $event)),
                  filterable: "",
                  placeholder: "请输入目标院校",
                  onChange: $setup.handleSelectCollege
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.collegeArr.university, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: index,
                        label: item.name,
                        value: item.name
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"]),
                _createVNode(_component_el_button, {
                  style: {"margin-left":"10px"},
                  type: "text",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _hoisted_60
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "院系",
              prop: "academy"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.userInfo.academy,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.userInfo.academy) = $event)),
                  placeholder: "请选择院系",
                  onChange: $setup.handleSelectAcademy
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.academyArr, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: index,
                        label: item.academyName,
                        value: item.academyName
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "专业",
              prop: "major"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.userInfo.major,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.userInfo.major) = $event)),
                  placeholder: "请选择专业",
                  onChange: $setup.handleSelectMajor
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.majorArr, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: index,
                        label: item.majorName,
                        value: item.majorName
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "方向" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.userInfo.direction,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.userInfo.direction) = $event)),
                  placeholder: "请选择方向"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.directionArr, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: index,
                        label: item.direction,
                        value: item.direction
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "入学时间",
              prop: "entranceTime"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.userInfo.entranceTime,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.userInfo.entranceTime) = $event)),
                  placeholder: "请输入学时间"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "政治",
              prop: "polScore"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.userInfo.polScore,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.userInfo.polScore) = $event)),
                  placeholder: "请输入政治成绩"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "英语几" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.userInfo.englishName,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.userInfo.englishName) = $event)),
                  placeholder: "请输入英语几"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "英语",
              prop: "engScore"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.userInfo.engScore,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.userInfo.engScore) = $event)),
                  placeholder: "请输入英语成绩"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "数学几" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.userInfo.mathName,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.userInfo.mathName) = $event)),
                  placeholder: "请输入数学几"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "专业课一名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.userInfo.zyk1Name,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.userInfo.zyk1Name) = $event)),
                  placeholder: "请输入专业课一名称"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "专业课一",
              prop: "zykOne"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.userInfo.zykOne,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.userInfo.zykOne) = $event)),
                  placeholder: "请输入专业课一成绩"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "专业课二名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.userInfo.zyk2Name,
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.userInfo.zyk2Name) = $event)),
                  placeholder: "请输入专业课二名称"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "专业课二" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.userInfo.zykTwo,
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.userInfo.zykTwo) = $event)),
                  placeholder: "请输入专业课二成绩"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "总分",
              prop: "totalScore"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.userInfo.totalScore,
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.userInfo.totalScore) = $event)),
                  placeholder: "请输入总分"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "复试成绩" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.userInfo.retestScore,
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.userInfo.retestScore) = $event)),
                  placeholder: "请输入复试成绩"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "初试排名" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.userInfo.initialRank,
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.userInfo.initialRank) = $event)),
                  placeholder: "请输入初试排名"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "复试排名" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.userInfo.againRank,
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.userInfo.againRank) = $event)),
                  placeholder: "请输入复试排名"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "总成绩排名" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.userInfo.totalRank,
                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.userInfo.totalRank) = $event)),
                  placeholder: "请输入总成绩排名"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "上岸途径",
              prop: "successWay"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.userInfo.successWay,
                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.userInfo.successWay) = $event)),
                  placeholder: "上岸途径",
                  onChange: $setup.handleSelectRoad
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "一志愿",
                      value: "1"
                    }),
                    _createVNode(_component_el_option, {
                      label: "调剂",
                      value: "2"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "辅导经验",
              prop: "guideExperience"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.userInfo.guideExperience,
                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.userInfo.guideExperience) = $event)),
                  placeholder: "是否有辅导经验",
                  onChange: $setup.handleSelectCoach
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "是",
                      value: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "否",
                      value: 0
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "渠道",
              prop: "channel"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.userInfo.channel,
                  "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.userInfo.channel) = $event)),
                  placeholder: "请输入渠道"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "专业课服务" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.userInfo.zykService,
                  "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.userInfo.zykService) = $event)),
                  placeholder: "请输入能提供的专业课服务"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "数学服务" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.userInfo.mathService,
                  "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.userInfo.mathService) = $event)),
                  placeholder: "请输入能提供的数学服务"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "政治服务" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.userInfo.politicsService,
                  "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.userInfo.politicsService) = $event)),
                  placeholder: "请输入能提供的政治服务"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "英语服务" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.userInfo.englishService,
                  "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.userInfo.englishService) = $event)),
                  placeholder: "请输入能提供的英语服务"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "其他服务" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.userInfo.otherService,
                  "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.userInfo.otherService) = $event)),
                  placeholder: "请输入能提供的其他服务"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "可提供的资料" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.userInfo.availInfo,
                  "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.userInfo.availInfo) = $event)),
                  placeholder: "请输入可提供的资料"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "辅导优势" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.userInfo.tutorAdvantage,
                  "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.userInfo.tutorAdvantage) = $event)),
                  placeholder: "请输入辅导优势"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "标签" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userInfo.tag, (tag) => {
                  return (_openBlock(), _createBlock(_component_el_tag, {
                    key: tag,
                    class: "mx-1",
                    closable: "",
                    "disable-transitions": false,
                    style: {"margin-right":"4px"},
                    onClose: ($event: any) => ($setup.handleCloseTag(tag))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(tag), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClose"]))
                }), 128)),
                (_ctx.inputVisible)
                  ? (_openBlock(), _createBlock(_component_el_input, {
                      key: 0,
                      ref: "InputRef",
                      modelValue: _ctx.inputValue,
                      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.inputValue) = $event)),
                      class: "ml-1 w-20",
                      size: "small",
                      autofocus: "",
                      onKeyup: _withKeys($setup.handleInputConfirm, ["enter"]),
                      onBlur: $setup.handleInputConfirm
                    }, null, 8, ["modelValue", "onKeyup", "onBlur"]))
                  : (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      class: "button-new-tag ml-1",
                      size: "small",
                      onClick: $setup.showInput
                    }, {
                      default: _withCtx(() => [
                        _hoisted_61
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "评价",
              prop: "label"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.userInfo.remark,
                  "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.userInfo.remark) = $event)),
                  type: "textarea",
                  autosize: "",
                  placeholder: "请输入该研究生的评价"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "学生证(一张)",
              prop: "studentIdCard"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  action: "#",
                  "list-type": "picture-card",
                  "http-request": $setup.uploadCardFile,
                  "file-list": _ctx.cardFile
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Plus)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["http-request", "file-list"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "成绩单(一张)" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  action: "#",
                  "list-type": "picture-card",
                  "http-request": $setup.uploadReportFile,
                  "file-list": _ctx.reportFile
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Plus)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["http-request", "file-list"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "录取通知书(一张)" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  action: "#",
                  "list-type": "picture-card",
                  "http-request": $setup.uploadOfferFile,
                  "file-list": _ctx.reportFile
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Plus)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["http-request", "file-list"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "拟录取截图(一张)" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  action: "#",
                  "list-type": "picture-card",
                  "http-request": $setup.uploadPreOfferFile,
                  "file-list": _ctx.reportFile
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Plus)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["http-request", "file-list"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, { onClick: $setup.closeForm }, {
                  default: _withCtx(() => [
                    _hoisted_62
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                  type: "primary",
                  onClick: _cache[42] || (_cache[42] = ($event: any) => ($setup.handleInsert($setup.ruleFormRef)))
                }, {
                  default: _withCtx(() => [
                    _hoisted_63
                  ]),
                  _: 1
                })), [
                  [
                    _directive_loading,
                    _ctx.editBtn,
                    void 0,
                    {
                      fullscreen: true,
                      lock: true
                    }
                  ]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["rules", "model", "onClick"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogVisible2,
      "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.dialogVisible2) = $event)),
      title: "研究生信息录入模板",
      width: "600px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          modelValue: _ctx.temp,
          "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.temp) = $event)),
          type: "textarea",
          autosize: ""
        }, null, 8, ["modelValue"]),
        _createVNode(_component_el_button, { type: "text" }, {
          default: _withCtx(() => [
            _hoisted_64
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}